<template lang="pug">
  div.body.body-table.service-table
    div.table-choose-panel
      div.toolbar-table
        div.select Обслуживание объекта
        //toolbarBlockClear
        // должна остаться вот такая структура:
        div.toolbar.toolbar--modal
          div.line
            // добавлен модификатор .search--rounded
            div.actions-panel
              e-button-add(@click="addNewRowToTable()")
              // button(v-if="role!=='guest'" @click="addNewRowToTable()").actions-panel__button.btn-add.green

      div
        e-table-editable(
        ref="operator"
          :attributes="operatorAttr"
            :dataUrl="operatorDataUrl"
            :postUrl="operatorPostUrl"
            :patchUrl="operatorPatchUrl"
            :deleteUrl="operatorDeleteUrl"
            :enableOnAdd="enableOnAdd"
            :afterFetchData="afterFetchData"
            :tableInOnlineMode="tableInOnlineMode"
        )
</template>

<script>
  import {msn, core, tko} from '../../../api/api-endpoints.js'
  import {msnOffline} from '../../../api/api-offline-endpoints.js'
  import {ACTIONS} from '../../../config/config'

  export default {
    name: 'service-table',
    props: {
      tabView: null,
      id: null
    },
    computed: {
      actionsList () {
        let arr = []
        for (let key in ACTIONS) {
          arr.push({
            id: ACTIONS[key].tko_action_id,
            name: ACTIONS[key].label
          })
        }
        return arr
      },
      tableInOnlineMode () {
        return this.$route.params.id
      },
      enableOnAdd () {
        return []
      },
      operatorAttr () {
        return {
          garbageGroupName: {
            label: 'Группа отходов',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название отхода',
            required: true,
            suggestion: {
              useInnerSearch: true,
              minSuggestLen: 0,
              options: [],
              onSelect: this.onSelectGarbageGroup,
              suggestionEndpoint: this.suggestionEndpointGarbageGroup,
              transformSuggestions: this.transformSuggestionsGarbageGroup
            }
          },
          tkoOperatorTransportName: {
            label: 'Транспортировщик',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название транспортировщика',
            required: true,
            suggestion: {
              useInnerSearch: true,
              options: [],
              onSelect: this.onSelectOperatorTransport,
              suggestionEndpoint: this.suggestionEndpointOperatorTransport ,
              transformSuggestions: this.transformSuggestionsOperatorTransport
            }
          },
          actionsIds: {
            label: 'Назначение',
            validationRulePattern: '(\\.*)',
            placeholder: '',
            suggestion: {
              multiple: true,
              useInnerSearch: true,
              minSuggestLen: 0,
              options: this.actionsList,
              onChange: (e) => e,
              showTags: false
            },
            transform: (model) => {
              let labels = []
              if (model.actionsIds && Array.isArray(model.actionsIds)) {
                model.actionsIds.forEach(id => {
                  let foundIndex = this.actionsList.findIndex(v => v.id == id)
                  if (foundIndex > -1) {
                    labels.push(this.actionsList[foundIndex].name)
                  }
                })
              }
              return labels.join(', ')
            }
          },
          tkoObjectName: {
            label: 'Объект обращения',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название объекта',
            suggestion: {
              useInnerSearch: true,
              options: [],
              onSelect: this.onSelectObject,
              suggestionEndpoint: this.suggestionEndpointObject,
              transformSuggestions: this.transformSuggestionsObject
            }
          },
          address: {
            label: 'Местоположение объекта',
            validationRulePattern: '(\\.*)',
            placeholder: ' ',
            disabled: true
          },
          tkoOperatorServiceName: {
            label: 'Эксплуатирующая организация',
            validationRulePattern: '(\\.*)',
            placeholder: 'Введите название оператора',
            suggestion: {
              useInnerSearch: true,
              options: [],
              onSelect: this.onSelectOperatorService,
              suggestionEndpoint: this.suggestionEndpointOperatorService,
              transformSuggestions: this.transformSuggestionsOperatorService
            }
          }
        }
      },
      operatorDataUrl () {
        if (this.tableInOnlineMode) {
          let routeQuery = {
            query: {
              sourceId: this.id
            }
          }
          return msn.service(routeQuery)
        }

        return msnOffline.serviceTable(this.$route.name)
      }
    },
    methods: {
      onSelectObject (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.tko_object_id = copy.id
          model.tkoObjectName = copy.tkoObjectName
          model.address = copy.address
        } else {
          model.address = ''
          model.tko_object_id = ''
          model.tkoObjectName = ''
        }
      },
      suggestionEndpointObject (ctx, q) {
        return tko.objects({query: {q: q, 'per-page': 50}})
      },
      transformSuggestionsObject (ctx, response) {
        let data = response.data
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].name,
            tkoObjectName: data[i].name,
            id: data[i].id,
            address: data[i].address
          })
        }
        return options
      },
      onSelectOperatorTransport (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.tko_operator_transport_id = copy.id
          model.tkoOperatorTransportName = copy.tkoOperatorTransportName
        } else {
          model.tko_operator_transport_id = ''
          model.tkoOperatorTransportName = ''
        }
      },
      suggestionEndpointOperatorTransport (ctx, q) {
        return core.statuses({fields: 'tko_operator_transport'})
      },
      transformSuggestionsOperatorTransport (ctx, response) {
        let data = response.tko_operator_transport
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].name,
            tkoOperatorTransportName: data[i].name,
            id: data[i].id
          })
        }
        return options
      },
      onSelectOperatorService (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.tko_operator_id = copy.id
          model.tkoOperatorServiceName = copy.tkoOperatorServiceName
        } else {
          model.tko_operator_id = ''
          model.tkoOperatorServiceName = ''
        }
      },
      suggestionEndpointOperatorService (ctx, q) {
        return core.statuses({fields: 'tko_operator'})
      },
      transformSuggestionsOperatorService (ctx, response) {
        let data = response.tko_operator
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].name,
            tkoOperatorServiceName: data[i].name,
            id: data[i].id
          })
        }
        return options
      },
      onSelectGarbageGroup (ctx, $event, model, attr) {
        if ($event && $event.id) {
          let copy = Object.assign({}, $event)
          model.group_id = copy.id
          model.garbageGroupName = copy.garbageGroupName
        } else {
          model.group_id = ''
          model.garbageGroupName = ''
        }
      },
      suggestionEndpointGarbageGroup (ctx, q) {
        return core.statuses({fields: 'garbage_group'})
      },
      transformSuggestionsGarbageGroup (ctx, response) {
        let data = response.garbage_group
        let options = []
        for (let i = 0; i < data.length; i++) {
          options.push({
            name: data[i].name,
            garbageGroupName: data[i].name,
            id: data[i].id
          })
        }
        return options
      },
      afterFetchData (ctx, data) {
        for (let i = 0; i < data.data.length; i++) {
          if (data.data[i].tko_operator) {
            data.data[i].tkoOperatorServiceName = data.data[i].tko_operator.name
          }
          if (data.data[i].group) {
            data.data[i].garbageGroupName = data.data[i].group.name
          }
          if (data.data[i].tko_operator_transport) {
            data.data[i].tkoOperatorTransportName = data.data[i].tko_operator_transport.name
          }
          if (data.data[i].tko_object) {
            data.data[i].tkoObjectName = data.data[i].tko_object.name
            data.data[i].address = data.data[i].tko_object.address
          }
        }
        return data
      },
      operatorPostUrl (context, model) {
        return msn.servicePost(this.id)
      },
      operatorPatchUrl (context, model) {
        return msn.servicePatch(this.id, model.id)
      },
      operatorDeleteUrl (context, model) {
        return msn.serviceDelete(this.id, model.id)
      },
      addNewRowToTable () {
        this.$refs.operator.createRow({
          tkoOperatorServiceName: '',
          tkoOperatorTransportName: '',
          tkoObjectName: '',
          address: '',
          garbageGroupName: ''
        })
      }
    }
  }
</script>
